import { render, staticRenderFns } from "./VaModal.demo.vue?vue&type=template&id=37bf7ad1&"
import script from "./VaModal.demo.vue?vue&type=script&lang=js&"
export * from "./VaModal.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports